import styled from "styled-components";
import { theme } from "../../css/Global";
import { deviceType } from "../../utils";

export const PersuasionTileStyles = styled.div<any>`
  background: ${(props) => props.bgColor};
  border-radius: 4px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px 8px 8px;
  ${(props) => props.margin && `margin: ${props.margin};`}
`;

export const LabelTag = styled.p`
  padding: 0;
  font-size: 12px;
  line-height: 18px;
  margin: 0 0 0 4px;
  color: ${theme.blackText};

  .blackBoldText {
    font-weight: 700;
  }

  .greenBoldText {
    font-weight: 700;
    color: ${theme.greenText};
  }

  @media screen and ${deviceType.mobile} {
    margin-left: 0px;
  }
`;
